import { render, staticRenderFns } from "./footBg.vue?vue&type=template&id=fecb311c"
import script from "./footBg.vue?vue&type=script&lang=js"
export * from "./footBg.vue?vue&type=script&lang=js"
import style0 from "./footBg.vue?vue&type=style&index=0&id=fecb311c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports